<div class="container-fluid">
<div class="row">
	<div class="col-12 px-0">
		<div class="footer text-center" *ngIf="this.url.includes( 'arrivae') || this.url.indexOf('arrivae') !== -1 ">
			<p class="mb-0">All Rights Reserved © 2019 | Arrivae</p>
		</div>
		<div class="footer text-center" *ngIf="this.url.includes( 'polkahouse') || this.url.indexOf('polkahouse') !== -1 ">
			<p class="mb-0">All Rights Reserved © 2019 | Polka House</p>
		</div>
	</div>
</div>
</div>



// WEBPACK FOOTER //
// ./src/app/shared/customer-footer/customer-footer.component.html